export const formatPrice = (price) => {
    if (!price || String(price).trim() === '0' || price === 0) return 'Sob Consulta';

    // Convert to string to check format
    const priceStr = String(price).trim();

    if (priceStr.toLowerCase() === 'sob consulta') return 'Sob Consulta';

    // If it contains a currency symbol, slash, or typical text letters (excluding standard formatting characters)
    if (priceStr.includes('€') || priceStr.includes('/') || /[a-zA-ZÀ-ÿ]/.test(priceStr)) {
        return priceStr;
    }

    // If it already contains dots or commas (simple check), return with currency suffix
    if (priceStr.includes('.') || priceStr.includes(',')) {
        return priceStr.endsWith('€') ? priceStr : `${priceStr} €`;
    }

    const cleanPrice = priceStr.replace(/\s/g, '');
    const numberPrice = Number(cleanPrice);
    if (isNaN(numberPrice)) return `${priceStr} €`; // Fallback

    // de-DE locale uses dots for thousands
    return `${numberPrice.toLocaleString('de-DE')} €`;
};
